export default "__VITE_ASSET__DAf7Qtd9__"